import { MatchScoreCapabilityTypes, SRMatchStatus, SRStatus, SupplierRequestSources } from './enums';
import { EntityTypes } from './enums/entityTypes';
import { SearchDatabaseOptions } from './enums/searchDatabaseOptions';

export interface SupplierRequest {
  orgId: string;
  requestId: string;
  userId: string;
  token: string;
  entityType: EntityTypes.supplierRequest;
  category?: string;
  subCategory?: string;
  projectName: string;
  description: string;
  creatorName: string;
  creatorTitle: string;
  source?: SupplierRequestSources;
  locations?: string[];
  timeframe?: string;
  budget?: string;
  unitVolume?: string;
  documents?: SupplierRequestDoc[];
  draft?: boolean;
  relatedNAICSCodes?: SupplierRequestNAICS[];
  qualifiedPrimaryBusinessActivities?: SupplierRequestPrimaryBusinessActivity[];
  qualifiedProductAndServices?: SupplierRequestProductAndService[];
  requirements?: SupplierRequestRequirements;
  requiredProductsAndServices?: string[];
  supplierCapabilities?: SupplierCapability[];
  assessmentCreated?: boolean;
  assessment?: SupplierRequestDoc;
  questions?: {
    [key: string]: string;
  };
  topPicks?: {
    [key: string]: SelectedSupplier;
  };
  suppliersUnderConsideration?: {
    [key: string]: SelectedSupplier;
  };
  status: SRStatus;
  matchStatus: SRMatchStatus;
  matchCount?: number;
  matchesNotified?: boolean;
  supplierPreference: string[];
  databasePreference: SearchDatabaseOptions;
  created: number;
  lastUpdated: number;
}

export interface SupplierCapability {
  capability: string;
  category: MatchScoreCapabilityTypes;
}
export interface SupplierRequestRequirements {
  [key: string]: string[];
}
export interface SupplierRequestNAICS {
  code: string;
  name: string;
  confidence: number;
}

export interface SupplierRequestPrimaryBusinessActivity {
  name: string;
  confidence: number;
}

export interface SupplierRequestProductAndService {
  name: string;
  confidence: number;
}

export interface SupplierRequestDoc {
  fileName: string;
  key: string;
  contentType: string;
}

export interface CreateSupplierRequestInput {
  orgId?: string;
  userId?: string;
  category?: string;
  subCategory?: string;
  projectName?: string;
  description?: string;
  creatorName?: string;
  creatorTitle?: string;
  locations?: string[];
  timeframe?: string;
  budget?: string;
  draft?: boolean;
  unitVolume?: string;
  questions?: string[];
  documents?: SupplierRequestDoc[];
  supplierPreference: string[];
  databasePreference: SearchDatabaseOptions;
  topPicks?: {
    [key: string]: SelectedSupplier;
  };
  suppliersUnderConsideration?: {
    [key: string]: SelectedSupplier;
  };
}

export interface SelectedSupplier {
  orgId: string;
  orgName: string;
  supplierMatchScore?: number;
  demographicDesignations?: string[];
}

export interface SupplierRequestItem
  extends Omit<SupplierRequest, 'requestId'> {
  PK: string;
  requestId?: string;
}

export interface SupplierRequestInput {
  projectName: string;
  description: string;
  timeframe: string;
  budget: string;
  unitVolume: string;
  creatorName: string;
  creatorTitle: string;
  locations: string;
  questions: string[];
  documents: SupplierRequestDoc[];
  supplierPreference: string[];
  databasePreference?: SearchDatabaseOptions;
  topPicks?: {
    [key: string]: SelectedSupplier;
  };
  suppliersUnderConsideration?: {
    [key: string]: SelectedSupplier;
  };
  category: string;
  subCategory: string;
}
